import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { FeaturedProject } from "../components/FeaturedProject";
import { Projects } from "../components/Projects";
import { Approach } from "../components/Approach";
import { About } from "../components/About";
import { Testimonials } from "../components/Testimonials";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "../lib/scroll";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const timer = setTimeout(() => scrollToSection(location.state.scrollTo), 400);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-basalt font-sans text-sand" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Approach />
        <Marquee />
        <FeaturedProject />
        <Projects />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
